const getSelectedGoalFromMeResp = (meResp, followedGoalsResp) => {
  let selectedGoalUid;
  let selectedGoal;
  if (meResp?.rawResponse?.latest_user_subscriptions_type_wise?.length > 0) {
    const goalItem =
      meResp.rawResponse.latest_user_subscriptions_type_wise[0].subscription
        .value;
    selectedGoalUid = goalItem.uid;
    selectedGoal = {
      ...goalItem,
      goalSlug: goalItem.relative_link.split('/')[2]
    };
  } else if (followedGoalsResp?.rawResponse?.length > 0) {
    const goalItem = followedGoalsResp.rawResponse[0];
    selectedGoalUid = goalItem.uid;
    selectedGoal = {
      ...goalItem,
      goalSlug: goalItem.relative_link.split('/')[2]
    };
  }

  return { selectedGoalUid, selectedGoal };
};

export default getSelectedGoalFromMeResp;
